import Button, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ElementRef, forwardRef, ReactNode } from 'react';

export interface ILoadingButtonProps extends Omit<MuiButtonProps, 'children'> {
  children: ReactNode;
  isLoading?: boolean;
  target?: string;
}

const LoadingButton = forwardRef<ElementRef<typeof Button>, ILoadingButtonProps>((props, ref) => {
  const { children, color, disabled, isLoading = false, startIcon, ...restMuiProps } = props;

  return (
    <Button
      ref={ref}
      disabled={isLoading || disabled}
      startIcon={isLoading ? null : startIcon}
      color={color}
      {...restMuiProps}
    >
      {isLoading ? <CircularProgress color={color && color !== 'inherit' ? color : 'inherit'} size={24} /> : children}
    </Button>
  );
});

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
